import React from "react";

const hostname = (url) => new URL(url).hostname.replace(/^www\./, "");

export const BrowserFrame = ({ src, url, alt = "", onOpen, eager }) => (
  <div className="browser">
    <div className="browser__bar" aria-hidden="true">
      <span className="browser__dots">
        <i />
        <i />
        <i />
      </span>
      <span className="browser__url mono">{hostname(url)}</span>
    </div>
    <button type="button" className="browser__screen" onClick={() => onOpen?.(src, alt)} aria-label={`Enlarge: ${alt}`}>
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} width="1440" height="900" />
    </button>
  </div>
);

export const PhoneFrame = ({ src, alt = "", onOpen, className = "" }) => (
  <div className={`phone ${className}`}>
    <span className="phone__island" aria-hidden="true" />
    <button type="button" className="phone__screen" onClick={() => onOpen?.(src, alt)} aria-label={`Enlarge: ${alt}`}>
      <img src={src} alt={alt} loading="lazy" width="540" height="1169" />
    </button>
  </div>
);
